/* eslint-disable @typescript-eslint/type-annotation-spacing */
import { AxiosResponse } from 'axios'
import SessionData, { refreshTokens } from '../../../services/session/SessionData'
import { AuthenticationMethod } from '../../DTO'
import SecureClient from '../SecureClient'

export class AuthenticationClient extends SecureClient {

	public refresh()
		: Promise<AxiosResponse | undefined> {

		const refreshToken = SessionData.refreshToken;

		if (refreshToken.raw === undefined)
			throw new Error('cannot refresh, refresh token is undefined')

		return refreshTokens(refreshToken.raw)
	}

	public secureHeartBeat = (): Promise<AxiosResponse> =>
		this._api.get('authentication/login',
			{
				headers: {
					...this.authorizationHeader
				}
			})

}

export class SignInClient extends SecureClient {
	public getAuthenticationMethod = (username: string):
		Promise<AxiosResponse<AuthenticationMethod>> =>
		this._api.get<AuthenticationMethod>(`authentication/login/${username}/authMethod`, {
			headers: {
				...this.acceptHeader()
			}
		})

	public getOrganizationAuthenticationMethods = (): Promise<AxiosResponse<AuthenticationMethod[]>> =>
		this._api.get<AuthenticationMethod[]>(`authentication/OrganizationAuthMethods`, {
			headers: {
				...this.acceptHeader()
			}
		})

	public getDefaultOrganizationAuthenticationMethod = (): Promise<AxiosResponse<AuthenticationMethod>> =>
		this._api.get<AuthenticationMethod>(`authentication/OrganizationAuthMethods/Default`, {
			headers: {
				...this.acceptHeader()
			}
		})
}

